import {Log} from '@aboutyou/mlm';
import {usePathname} from '@aboutyou/router';
import {FC, useEffect, useRef} from 'react';

export const LogLostScrollPosition: FC = () => {
  const pathname = usePathname();
  const pathnameRef = useRef(pathname);

  useEffect(() => {
    if (pathnameRef.current !== pathname) {
      pathnameRef.current = pathname;

      const timeout = setTimeout(checkAndLogScrollPosition, 100);
      return () => clearTimeout(timeout);
    }
  }, [pathname]);

  return null;
};

const checkAndLogScrollPosition = () => {
  const {scrollY, innerHeight} = window;
  const {scrollHeight} = document.documentElement;
  const heightFromBottom = Math.abs(scrollHeight - innerHeight - scrollY);
  const isAtBottom = heightFromBottom < 100;

  if (isAtBottom) {
    Log.unSampledLog('LOST_SCROLL_POSITION', {
      scrollY,
      scrollHeight,
      innerHeight,
      heightFromBottom,
    });
  }
};
